import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { cacheBustingReload } from "@/lib/lazyWithRetry";
import { startVersionWatcher } from "@/lib/versionWatcher";

// Global runtime error logging to help diagnose blank pages
window.addEventListener("error", (event) => {
  console.error("[Global Error]", event.error || event.message);
});
window.addEventListener("unhandledrejection", (event) => {
  console.error("[Unhandled Rejection]", event.reason);
});

// A page file failed to preload (usually a stale file after a new publish):
// recover with a fresh load before the page tries to render.
window.addEventListener("vite:preloadError", (event) => {
  if (cacheBustingReload()) event.preventDefault();
});

startVersionWatcher();

createRoot(document.getElementById("root")!).render(<App />);
